import * as yup from 'yup'

const schema = (openingDateRef) =>
  yup.object({
    name: yup.string().required(),
    plannedChange: yup.string().required(),
    responsibleId: yup.mixed().required(),
    identifiedById: yup.mixed().required(),
    openingDate: yup
      .date()
      .nullable()
      .required()
      .test(
        'openingDate-vs-deadline',
        'Data de abertura não pode ser maior que o prazo previsto',
        function (value) {
          const { deadline } = this.parent
          if (!value || !deadline) return true
          return new Date(value) <= new Date(deadline)
        },
      )
      .test(
        'openingDate-vs-conclusionDate',
        'Data de abertura não pode ser maior que a data de conclusão',
        function (value) {
          const { conclusionDate } = this.parent
          if (!value || !conclusionDate) return true
          return new Date(value) <= new Date(conclusionDate)
        },
      ),
    deadline: yup.date().nullable().required(),
    conclusionDate: yup.date().nullable(),
    approvedById: yup.mixed().required(),
    purposeOfChange: yup.string().required(),
    evidencePlanActions: yup.array().of(
      yup.object({
        evidence: yup.object({
          title: yup.string().required(),
          description: yup.string().required(),
          justify: yup.string().required(),
        }),
        planActions: yup.array().of(
          yup.object({
            responsible: yup.object().nullable().required(),
            deadlineDate: yup
              .date()
              .nullable()
              .required()
              .test(
                'deadlineDate-after-openingDate',
                'Prazo não pode ser menor que a data de abertura',
                function (value) {
                  if (!value) return true
                  const openingDate = openingDateRef?.current
                  if (!openingDate) return true
                  return new Date(value) >= new Date(openingDate)
                },
              ),
            what: yup.string().required(),
          }),
        ),
      }),
    ),
  })

export default schema
